/*
  Seletor de variantes da PDP.

  Por que existe: a grade de numeracao era decorativa. Os radios se chamavam
  `brisa-grade-<secao>`, que nao e campo de carrinho, nenhum script os lia, e o
  formulario mandava um `<input name="id">` fixo. Clicar em GG e comprar M era o
  comportamento normal da loja. A opcao de cor nem chegava a ser desenhada.

  Como funciona: cada grade e um grupo (`[data-brisa-opcao]`) cujo indice bate
  com a posicao do valor dentro de `opcoes` no JSON das variantes. Trocou
  qualquer radio, a combinacao inteira e remontada, casada com a variante e
  escrita no campo do carrinho.

  AUTO-CORRECAO: escolher um valor nunca pode dar em beco sem saida. Se o
  cliente esta em (Preto, M) e clica em Azul, que nao tem M, o tamanho pula
  sozinho para um que exista em Azul — em vez de o clique ser ignorado ou a cor
  aparecer travada. Quem escolhe manda; o resto se ajusta em volta.

  Preco, parcelas e estoque NAO sao recalculados aqui de proposito: as regras
  (desconto Pix, piso de parcela, faixas da barra) vivem no Liquid, e reescreve-
  las em JS criaria duas verdades que divergem na primeira mudanca. Em vez disso
  pedimos a propria secao renderizada para a variante nova
  (`?section_id=...&variant=...`) e trocamos so os blocos marcados.

  Se este arquivo falhar, o Liquid ja deixou um id valido no formulario — a
  loja volta ao comportamento antigo em vez de quebrar.
*/
(() => {
  /*
    A galeria entra aqui porque as fotos sao filtradas por cor no Liquid (pelo
    alt "<titulo> — <cor>"). Sem trocar este bloco, clicar em Branco/Prata
    mudava o preco e o SKU mas deixava na tela o tenis preto da cor anterior.

    Ela e IRMA da raiz, nao filha: a raiz e `.brisa-compra` (quem tem o
    data-brisa-variantes) e a galeria fica na coluna da esquerda. Por isso a
    busca abaixo usa `.brisa-produto`, que envolve as duas.
  */
  const BLOCOS = ['[data-brisa-galeria]', '[data-brisa-preco]', '[data-brisa-estoque]', '[data-brisa-sku]'];
  const BOTOES = ['[data-brisa-add]', '[data-brisa-comprar]'];

  function ligar(raiz) {
    const fonte = raiz.querySelector('[data-brisa-variantes-json]');
    const campoId = raiz.querySelector('input[name="id"]');
    const grupos = [...raiz.querySelectorAll('[data-brisa-opcao]')];
    if (!fonte || !campoId || grupos.length === 0) return;

    let variantes;
    try {
      variantes = JSON.parse(fonte.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(variantes) || variantes.length === 0) return;

    const urlProduto = raiz.dataset.produtoUrl;
    const idSecao = raiz.dataset.secao;

    const escolhidos = () =>
      grupos.map((g) => {
        const m = g.querySelector('input:checked');
        return m ? m.value : null;
      });

    const marcar = (gi, valor) => {
      const alvo = grupos[gi].querySelector(`.brisa-grade__input[value="${CSS.escape(valor)}"]`);
      if (alvo && !alvo.checked) alvo.checked = true;
    };

    /*
      Existe variante EM ESTOQUE com este valor nesta posicao, respeitando o que
      esta escolhido nas outras? Disponibilidade e da combinacao: o 42 pode
      existir em preto e faltar em branco.
    */
    const combinaDisponivel = (combo) =>
      variantes.some((v) => v.disponivel && combo.every((x, i) => x === null || v.opcoes[i] === x));

    function pintar() {
      const combo = escolhidos();

      grupos.forEach((g, gi) => {
        g.querySelectorAll('.brisa-grade__input').forEach((inp) => {
          const teste = combo.slice();
          teste[gi] = inp.value;
          const existe = combinaDisponivel(teste);
          /*
            So a CLASSE marca o esgotado. Nada de `disabled` nem `aria-disabled`:
            o valor continua clicavel de proposito, porque clicar nele reajusta
            as outras opcoes (ver auto-correcao no topo). Marcar como desabilitado
            prenderia o cliente na combinacao atual e mentiria para o leitor de
            tela, que anunciaria como inerte algo que responde ao toque.
          */
          inp.closest('.brisa-grade__opcao').classList.toggle('brisa-grade__opcao--off', !existe);
        });

        const marcado = g.querySelector('input:checked');
        const rotulo = raiz.querySelector(`[data-brisa-escolhido="${g.dataset.brisaOpcao}"]`);
        if (rotulo && marcado) rotulo.textContent = marcado.value;
      });
    }

    async function trocarBlocos(idVariante) {
      try {
        const r = await fetch(`${urlProduto}?section_id=${idSecao}&variant=${idVariante}`);
        if (!r.ok) return;
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const escopo = raiz.closest('.brisa-produto') || raiz;
        BLOCOS.forEach((sel) => {
          const novo = doc.querySelector(sel);
          const velho = escopo.querySelector(sel);
          // outerHTML porque o estado tambem vive na CLASSE (brisa-estoque--fora)
          if (novo && velho) velho.outerHTML = novo.outerHTML;
        });
        BOTOES.forEach((sel) => {
          const novo = doc.querySelector(sel);
          const velho = escopo.querySelector(sel);
          if (!novo || !velho) return;
          velho.disabled = novo.hasAttribute('disabled');
          velho.innerHTML = novo.innerHTML;
        });
        // a galeria trocada perdeu os listeners das setas junto com o HTML velho
        document.dispatchEvent(new CustomEvent('brisa:blocos-trocados'));
      } catch (e) {
        /* preco desatualizado e ruim, mas o id no carrinho ja esta correto */
      }
    }

    function trocou(evento) {
      const grupoMudou = grupos.findIndex((g) => g.contains(evento.target));
      const combo = escolhidos();
      if (combo.some((x) => x === null)) return;

      let alvo = variantes.find((v) => v.opcoes.every((o, i) => o === combo[i]));

      /*
        Combinacao inexistente ou esgotada: mantem o que a pessoa acabou de
        clicar e reescolhe o resto. Prefere a variante que conserva o maior
        numero de escolhas anteriores, para o clique mudar o minimo possivel.
      */
      if ((!alvo || !alvo.disponivel) && grupoMudou > -1) {
        const fixo = combo[grupoMudou];
        const candidatas = variantes.filter((v) => v.disponivel && v.opcoes[grupoMudou] === fixo);
        if (candidatas.length) {
          let melhor = candidatas[0];
          let melhorNota = -1;
          candidatas.forEach((v) => {
            const nota = v.opcoes.reduce((s, o, i) => s + (o === combo[i] ? 1 : 0), 0);
            if (nota > melhorNota) {
              melhorNota = nota;
              melhor = v;
            }
          });
          alvo = melhor;
          alvo.opcoes.forEach((valor, i) => marcar(i, valor));
        }
      }

      pintar();
      if (!alvo) return;

      campoId.value = alvo.id;

      // `?variant=` na barra faz o link compartilhado abrir na escolha certa
      const u = new URL(window.location.href);
      u.searchParams.set('variant', alvo.id);
      window.history.replaceState({}, '', u);

      trocarBlocos(alvo.id);
    }

    grupos.forEach((g) => g.addEventListener('change', trocou));
    pintar();
  }

  const iniciar = () => document.querySelectorAll('[data-brisa-variantes]').forEach(ligar);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
